CategoryCard = require './CategoryCard'

class Header

  constructor: ->
    @init()

  init: ->
    @state =
      $currentUserMenu: null
      $currentNav: null

    @$win  = $(window)
    @$body = $('body')

    @$headerOverlay = $('<div class="headerOverlay">').hide()

    @$body.append(@$headerOverlay)


    # グローバルナビ関連
    @$btnNavOpen  = $('.header_btnMenu')
    @$btnNavClose = $('.header_btnMenuClose')
    @$globalNav   = $('.globalNav')
    @$globalNavMin   = $('.globalNav-min')
    @$globalNavItemList = @$globalNav.find('.globalNav_item')
    @$globalNavItems = @$globalNav.find('.globalNav_item > a')
    @$globalNavWork = @$globalNav.find('.globalNav_item-work')
    @$globalNavLife = @$globalNav.find('.globalNav_item-life')
    @$globalNavVoice = @$globalNav.find('.globalNav_item-voice')

    @$globalNavLinkList = @$globalNav.find('.inner_body_list').children('li')


    @setGlobalNav()
    @setUserMenu()
    @setGlobalNavMin()

    if !@$body.hasClass('is-sp')
      @setCategoryCard()

    @$globalNavLinkList.on 'mouseenter', ->
      $(this).find('.inner_body_list_text').addClass('c_text');
      return
    @$globalNavLinkList.on 'mouseleave', ->
      $(this).find('.inner_body_list_text').removeClass('c_text');
      return

  setGlobalNav: ->
    _t = @

    if !_t.$body.hasClass('is-tablet')
      @$globalNavItems.on 'mouseenter', ->
        if !$(this).parent('li').hasClass('btnVote') || !$(this).parent('li').hasClass('btnSf2030')
          if app.layoutSequencer.getLayout() != 'layout3'
            $(this).next('.globalNav_item_wrapper').stop().fadeIn(300)
            $(this).parent('li').addClass('active')

      @$globalNavItems.on 'click', ->
        if $(this).parent('li').hasClass('btnVote') || $(this).parent('li').hasClass('btnSf2030') || $(this).parent('li').hasClass('globalNav_item-news') || $(this).parent('li').hasClass('globalNav_item-about')
          hogeClick=true
        else
          return false

      @$globalNavItemList.on 'mouseleave', ->
        if !$(this).hasClass('btnVote') || !$(this).hasClass('btnSf2030')
          if app.layoutSequencer.getLayout() != 'layout3'
            $(this).find('.globalNav_item_wrapper').stop().hide()
            $(this).removeClass('active')

      $('.header_nav').on 'mouseenter', ->
        if !$(this).find('.globalNav').children('li').hasClass('btnVote') || !$(this).find('.globalNav').children('li').hasClass('btnSf2030')
          if app.layoutSequencer.getLayout() != 'layout3'
            if _t.state.$currentUserMenu
              _t.state.$currentUserMenu.find('.userMenu').stop().hide()
              _t.state.$currentUserMenu.find('.btn').removeClass('active')
              _t.state.$currentUserMenu = null
            _t.$headerOverlay.stop().fadeIn(300)

      $('.header_nav').on 'mouseleave', ->
        if !$(this).find('.globalNav').children('li').hasClass('btnVote') || !$(this).find('.globalNav').children('li').hasClass('btnSf2030')
          if app.layoutSequencer.getLayout() != 'layout3'
            _t.$headerOverlay.stop().fadeOut(100)

    else
      @$globalNavItems.on 'click', ->
        $this = $(this)

        if app.layoutSequencer.getLayout() != 'layout3'
          if _t.state.$currentUserMenu
            _t.state.$currentUserMenu.find('.userMenu').stop().hide()
            _t.state.$currentUserMenu.find('.btn').removeClass('active')
            _t.state.$currentUserMenu = null

          if _t.state.$currentNav
            _t.state.$currentNav.stop().hide()
            _t.state.$currentNav.parent('li').removeClass('active')

            if _t.state.$currentNav.get(0) == $this.next('.globalNav_item_wrapper').get(0)
              _t.state.$currentNav.stop().hide()
              _t.$headerOverlay.stop().fadeOut(100)
              _t.state.$currentNav.parent('li').removeClass('active')
              _t.state.$currentNav = null
              return false

          _t.state.$currentNav = $this.next('.globalNav_item_wrapper')
          _t.state.$currentNav.stop().fadeIn(300)
          _t.$headerOverlay.stop().fadeIn(300)
          _t.state.$currentNav.parent('li').addClass('active')

          _t.$headerOverlay.off('click').on 'click', ->
            _t.state.$currentNav.stop().hide()
            _t.$headerOverlay.stop().fadeOut(100)
            _t.state.$currentNav.parent('li').removeClass('active')
            _t.state.$currentNav = null

        return false

    # 仮
    ##############################################
    @$btnNavOpen.on 'click', =>
      @$btnNavOpen.hide()
      @$btnNavClose.show()
      @$globalNavMin.show()
      @$headerOverlay.show().off().on 'click', =>
        @$btnNavClose.trigger 'click'

    @$btnNavClose.on 'click', =>
      @$btnNavOpen.show()
      @$btnNavClose.hide()
      @$globalNavMin.hide()
      @$headerOverlay.hide()

    app.layoutSequencer.on 'change', (state)=>
      if state.currentLayout != 'layout3'
        @$btnNavOpen.hide()
        @$btnNavClose.hide()
        @$globalNavMin.hide()
        @$headerOverlay.hide()
      else
        @$btnNavOpen.show()
        @$btnNavClose.hide()
        @$globalNavMin.hide()
        @$headerOverlay.hide()


  setGlobalNavMin: ->
    @$globalNavMin.find('.hasSubNav > a').on 'click', ->
      $this = $(this)
      $parent = $this.parent('li')
      if !$parent.hasClass('active')
        $parent.addClass('active')
        $this.next('.globalNav-min_item_subNav').stop().slideDown(200)
      else
        $parent.removeClass('active')
        $this.next('.globalNav-min_item_subNav').stop().slideUp(200)
      return false

  setCategoryCard: ->

    _t = @
    workCategoryCard = new CategoryCard(@$globalNavWork)
    lifeCategoryCard = new CategoryCard(@$globalNavLife)
    voiceCategoryCard = new CategoryCard(@$globalNavVoice)

    # 初期表示用（一番目のカテゴリーを選択）
    workCategoryCard.changeCard(0)
    lifeCategoryCard.changeCard(0)
    voiceCategoryCard.changeCard(0)

    @$globalNavWork.find('.subNav a').on 'click', ->
      if app.layoutSequencer.getLayout() != 'layout3'
        index = $(this).parent('li').index()
        workCategoryCard.changeCard(index)
        return false

    @$globalNavLife.find('.subNav a').on 'click', ->
      if app.layoutSequencer.getLayout() != 'layout3'
        index = $(this).parent('li').index()
        lifeCategoryCard.changeCard(index)
        return false

    @$globalNavVoice.find('.subNav a').on 'click', ->
      if app.layoutSequencer.getLayout() != 'layout3'
        index = $(this).parent('li').index()
        voiceCategoryCard.changeCard(index)
        return false


  setUserMenu: ->
    # ユーザーメニュー

    _t = @

    $('.header_userMenu .btn').on 'click', ->
      $this = $(this)
      $menu = $this.next('.userMenu')
      if _t.state.$currentNav
        _t.state.$currentNav.stop().hide()
        _t.$headerOverlay.stop().hide()
        _t.state.$currentNav.parent('li').removeClass('active')
        _t.state.$currentNav = null
      if !$menu.is(':visible')
        if _t.state.$currentUserMenu
          _t.state.$currentUserMenu.find('.userMenu').stop().hide()
          _t.state.$currentUserMenu.find('.btn').removeClass('active')
        $menu.stop().fadeIn(300)
        $this.addClass('active')
        _t.state.$currentUserMenu = $this.parent('.header_userMenu')

        if $this.parent('.header_userMenu').hasClass('header_userMenu-nices')
          if $this.find('.badge')[0]
            # console.log 'nice reade'
            options =
              callback: ->
                $this.find('.badge').remove()

            app.api.niceReadUpdate options

        else if $this.parent('.header_userMenu').hasClass('header_userMenu-comments')
          if $this.find('.badge')[0]
            # console.log 'comment reade'
            options =
              callback: ->
                $this.find('.badge').remove()

            app.api.commentReadUpdate options

      else
        $menu.stop().hide()
        $this.removeClass('active')
        _t.state.$currentUserMenu = null
      return false

    @$body.on 'click', (event)->
      if _t.state.$currentUserMenu
        if !$.contains(_t.state.$currentUserMenu[0], event.target)
          _t.state.$currentUserMenu.find('.userMenu').stop().hide()
          _t.state.$currentUserMenu.find('.btn').removeClass('active')
          _t.state.$currentUserMenu = null



module.exports = Header



// WEBPACK FOOTER //
// ./src/scripts/modules/Header.coffee